module.exports = __webpack_public_path__ + "img/UMCP-logo.4bc9803a.svg";